import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-slate-900 text-white py-12 px-6 md:px-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <GraduationCap className="h-8 w-8 text-indigo-400" />
              <span className="font-heading text-xl font-semibold">Gifted Academy</span>
            </Link>
            <p className="text-slate-400 text-sm">
              Expert tutoring services for high school and university students.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/tutors" className="text-slate-400 hover:text-white transition-colors">
                  Find Tutors
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-slate-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-slate-400 hover:text-white transition-colors">
                  Payment & Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/consent-policy" className="text-slate-400 hover:text-white transition-colors">
                  Parent/Guardian Consent
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Policies</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/session-policy" className="text-slate-400 hover:text-white transition-colors">
                  Session Policy
                </Link>
              </li>
              <li>
                <Link to="/acceptable-use" className="text-slate-400 hover:text-white transition-colors">
                  Acceptable Use Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-slate-800 pt-8 mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-slate-400 text-sm">
              <span className="mr-4">Email: contact@giftedacademytutors.ca</span>
              <span>Phone: 416-846-5062</span>
            </div>
            <div className="text-slate-400 text-sm">
              Toronto, Ontario, Canada
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} Gifted Academy Tutors. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs">
            Governed by the laws of Ontario, Canada
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
